import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        headerContainer: {
            width: '100%',
            minW: 0,
            paddingTop: remCalc(4),
            paddingX: {base: 0, lg: remCalc(4)},
            position: 'relative',
            zIndex: 1200,
            bg: 'background.base.default',
        },
        viewport: {
            height: remCalc(20),
            bgImage:
                'repeating-linear-gradient(to bottom, #9FAEBE 0px, #9FAEBE 1.5px, transparent 1.5px, transparent 4.5px)',
            bgSize: '100% 19.5px',
            bgRepeat: 'no-repeat',
            bgPosition: 'center',
            overflow: 'hidden',
            position: 'relative',
            zIndex: 1,
        },
        track: {
            width: 'max-content',
            flexShrink: 0,
            gap: remCalc(24),
            paddingRight: remCalc(24),
            _hover: {animationPlayState: 'paused'},
            _focusWithin: {animationPlayState: 'paused'},
            sx: {
                '@media (prefers-reduced-motion: reduce)': {animation: 'none'},
            },
        },
        group: {
            paddingX: remCalc(3),
            gap: remCalc(20),
            alignItems: 'flex-end',
        },
        link: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: 'max-content',
            minW: 0,
            height: remCalc(20),
            paddingX: remCalc(12),
            paddingY: 0,
            borderRadius: 'full',
            bg: 'background.base.default',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
            color: '#576D84',
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            boxShadow:
                '0 0 0 1.5px var(--slate-slate-400, #9FAEBE) inset, 0 0 0 3px var(--background-base-default, #EFEDEA)',
            _hover: {textDecoration: 'none'},
            cursor: 'pointer',
        },
    },
    parts: [
        'container',
        'label',
        'icon',
        'hstack',
        'headerContainer',
        'viewport',
        'track',
        'group',
        'link',
    ],
}
